// assets/cart-drawer.js — FINAL

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // ESC schließt
    this.addEventListener('keyup', (e) => e.code === 'Escape' && this.close());

    // EINMALIGE Delegation: Overlay & Close-Buttons (verhindert doppelte Listener)
    this.addEventListener('click', (e) => {
      if (e.target?.id === 'CartDrawer-Overlay') this.close();
      if (e.target?.closest('[data-drawer-close]')) this.close();
      if (e.target?.closest('.drawer__close')) this.close(); // falls Theme-Klasse genutzt wird
    });

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink || cartLink.dataset.bound === 'true') return; // verhindert Doppeltbindung

    cartLink.dataset.bound = 'true';
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code?.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // Animation zuverlässig triggern
    setTimeout(() => this.classList.add('animate', 'active'));

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
  // Klassen zurücksetzen
  this.classList.remove('active', 'animate');

  // Focus Trap defensiv lösen (falls vorhanden)
  try { if (this.activeElement) removeTrapFocus(this.activeElement); } catch (e) {}

  // Scroll-Lock am Body entfernen
  document.body.classList.remove('overflow-hidden');

  // Overlay hart verstecken (extra Sicherheitsnetz für iOS)
  const overlay = this.querySelector('#CartDrawer-Overlay');
  if (overlay) {
    overlay.style.display = 'none';
    // Aufräumen: fürs nächste Öffnen wieder freigeben
    setTimeout(() => { overlay.style.display = ''; }, 200);
  }
}


  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling?.id) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const inner = this.querySelector('.drawer__inner');
    if (inner?.classList.contains('is-empty')) inner.classList.remove('is-empty');

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // Wichtig: nach Re-Render Bubble wieder „verdrahten“
    this.setHeaderCartIconAccessibility();

    setTimeout(() => this.open());
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' }
    ];
  }

  // optional beibehalten (Kompatibilität)
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(el) { this.activeElement = el; }
}
customElements.define('cart-drawer', CartDrawer);

// Drawer-Items bleiben, aber hier komplett – damit du nur STRG+A/STRG+V brauchst
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
